import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import ContactForm from '../components/ContactForm';

const Contact = () => {
  return (
    <div className="terms-container">
      <div className="terms-wrapper">
        <Link to="/" className="back-link">
          <Button variant="ghost" className="back-button">
            <ArrowLeft className="back-icon" />
            Back to Home
          </Button>
        </Link>

        <div className="terms-content">
          <h1 className="terms-title">Contact Us</h1>
          <p className="intro-text">
            Have questions or need support? We're here to help! Fill out the form below or reach out to us directly via email.
          </p>

          <ContactForm />
        </div>
      </div>
    </div>
  );
};

export default Contact;
